export class HttpError<TBody> extends Error {
  public status: number;
  public statusText: string;
  public body: TBody;

  constructor(status: number, statusText: string, body: TBody) {
    super(`HTTP ${status} ${statusText}: ${JSON.stringify(body)}`);
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    this.name = 'RequestError';
    this.status = status;
    this.statusText = statusText;
    this.body = body;
  }
}
